/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };

type HookTuple = [response: vp.AccountTransactions, fetchData: (params: vp.ParentAccountTransactionsRequest) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchPartnerAccountTransactions: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.AccountTransactions>({
    Success: false,
    ErrorMessage: '',
  });
  const [params, setParams] = useState<vp.ParentAccountTransactionsRequest>({ FromDate: '', ToDate: '' });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const accountTransactionsResponse = await api.fetchPartnerAccountTransactions(params, source);
      setResponse(accountTransactionsResponse);

      setDataFetchingInfo(false);
    };

    if (shouldFetchData) void loadData();
    setShouldFetchData(false);

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (_params: vp.ParentAccountTransactionsRequest) => {
      setParams(_params);
      setShouldFetchData(true);
      return response;
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchPartnerAccountTransactions);
